import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as moment from 'moment';

import { Availability, TimeSlot, UserAvailabilityData } from '../models/availability';
import { IFilterAPI } from '../standalones/components/generic-filters-view/filters.interface';
import { URLService } from './dynamic-url.service';

export interface AvailabilityFilterAPI extends IFilterAPI {
  event: {
    start_time: Date;
    end_time: Date | undefined;
  };
}

export interface GetSlotsResponse {
  availability: {
    _id: string;
    user: string;
    slots: TimeSlot[];
  };
}

export interface GetAvailabilityResponse {
  users: UserAvailabilityData[];
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
}

@Injectable({
  providedIn: 'root',
})
export class AvailabilityService {
  readonly API_TIME_FORMAT = 'HH:mm';
  readonly DISPLAY_TIME_FORMAT = 'hh:mm a';

  constructor(private urlService: URLService, private http: HttpClient) {}

  createUpdateSlots(availability: Availability): Observable<object> {
    return this.http.post(
      `${this.urlService.getDynamicUrl()}/availability/slots/${availability.userId}`,
      availability,
    );
  }

  getSlots(userId: string): Observable<GetSlotsResponse> {
    return this.http.get<GetSlotsResponse>(
      `${this.urlService.getDynamicUrl()}/availability/slots/${userId}`,
    );
  }

  getAvailableTutors(
    filters: AvailabilityFilterAPI,
    pageNumber: number,
    pageSize: number,
  ): Observable<GetAvailabilityResponse> {
    return this.http.get<GetAvailabilityResponse>(
      `${this.urlService.getDynamicUrl()}/availability`,
      {
        params: {
          filters: btoa(JSON.stringify(filters)),
          pageNumber,
          pageSize,
        },
      },
    );
  }

  convertToDisplayTimeFormat(time: string): string {
    return time ? moment(time, this.API_TIME_FORMAT).format(this.DISPLAY_TIME_FORMAT) : '';
  }

  convertToApiTimeFormat(time: string): string {
    return time ? moment(time, this.DISPLAY_TIME_FORMAT).format(this.API_TIME_FORMAT) : '';
  }
}
